export const SITE_SCANNER_APP_ID = '#root';
